// Lightweight client-side PDF page counter.
// Works for the vast majority of PDFs (uncompressed and many compressed) without
// pulling in pdfjs-dist (~3 MB). Returns null when it can't determine.
async function countPdfPages(file) {
  try {
    const buf = await file.arrayBuffer();
    const bytes = new Uint8Array(buf);
    // Latin1 keeps every byte as a single code unit, ideal for binary scanning
    const text = new TextDecoder("latin1").decode(bytes);
    // 1) Look up /Type /Pages ... /Count N (the page tree root carries this)
    const m1 = text.match(/\/Type\s*\/Pages[\s\S]{0,800}?\/Count\s+(\d+)/);
    if (m1) {
      const n = parseInt(m1[1], 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
    // 2) Fallback: count "/Type /Page" entries (excluding "/Type /Pages")
    const m2 = text.match(/\/Type\s*\/Page[^s]/g);
    if (m2 && m2.length > 0) return m2.length;
    return null;
  } catch (_e) {
    return null;
  }
}

export async function countPages(file) {
  const name = (file.name || "").toLowerCase();
  if (file.type === "application/pdf" || name.endsWith(".pdf")) {
    return await countPdfPages(file);
  }
  if ((file.type || "").startsWith("image/")) {
    return 1;
  }
  // Word, Excel and other formats: real page counting requires heavy parsing.
  return null;
}

export function randomKpCode() {
  const n = 1000 + Math.floor(Math.random() * 9000);
  return `KP-${n}`;
}
